<!-- Header - Outside Sidenav -->
<header class="modern-header">
  <nav class="nav-container">
    <!-- Logo Section -->
    <div class="logo-section" (click)="navigate('/stolbovi')">
      <img class="logo-img" src="assets/images/logo-new.svg" alt="Telekom Logo" />
      <div class="app-title">
        <span class="title-main">Столбови</span>
      </div>
    </div>

    <!-- Desktop Navigation -->
    <div class="nav-links" *ngIf="!isMobile">
      <button class="nav-link"
              *ngIf="!authService.isAdmin()"
              (click)="navigate('stolbovi/add')">
        <mat-icon>add_circle_outline</mat-icon>
        <span>Додади Столб</span>
      </button>

      <button class="nav-link"
              *ngIf="authService.isAdmin() || authService.isUser()"
              (click)="navigate('/stolbovi')">
        <mat-icon>foundation</mat-icon>
        <span>Столбови</span>
      </button>

      <button class="nav-link"
              *ngIf="authService.isAdmin() || authService.isUser()"
              (click)="navigate('stolbovi/map')">
        <mat-icon>map</mat-icon>
        <span>Мапа</span>
      </button>

      <button class="nav-link"
              *ngIf="authService.isAdmin()"
              (click)="navigate('/reports')">
        <mat-icon>assessment</mat-icon>
        <span>Извештаи</span>
      </button>
    </div>

    <!-- User Profile & Menu -->
    <div class="user-section">
      <button class="user-profile" [matMenuTriggerFor]="userMenu" *ngIf="data">
        <div class="user-avatar">
          <span>{{data.firstName?.charAt(0)}}{{data.lastName?.charAt(0)}}</span>
        </div>
        <div class="user-info" *ngIf="!isMobile">
          <span class="user-name">{{data.firstName}} {{data.lastName}}</span>
          <span class="user-role">{{authService.isAdmin() ? 'Администратор' : 'Техничар'}}</span>
        </div>
        <mat-icon class="dropdown-icon">expand_more</mat-icon>
      </button>

      <!-- Mobile Menu Button -->
      <button mat-icon-button class="mobile-menu-btn" (click)="toggleSidebar()" *ngIf="isMobile">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </nav>

  <!-- User Dropdown Menu -->
  <mat-menu #userMenu="matMenu" class="user-dropdown">
    <div class="user-menu-header">
      <div class="user-avatar-large">
        <span>{{data?.firstName?.charAt(0)}}{{data?.lastName?.charAt(0)}}</span>
      </div>
      <div class="user-details">
        <p class="user-name-full">{{data?.firstName}} {{data?.lastName}}</p>
        <p class="user-email">{{data?.username}}</p>
      </div>
    </div>
    <mat-divider></mat-divider>

    <button mat-menu-item *ngIf="authService.isAdmin()" (click)="navigate('/users')">
      <mat-icon>people</mat-icon>
      <span>Корисници</span>
    </button>

    <button mat-menu-item *ngIf="authService.isAdmin()" (click)="navigate('/operators')">
      <mat-icon>wifi_tethering</mat-icon>
      <span>Оператори</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item class="logout-btn" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Одјави се</span>
    </button>
  </mat-menu>
</header>

<!-- Mobile Sidebar - Separate from Header -->
<mat-sidenav-container class="sidenav-container" *ngIf="isMobile">
  <mat-sidenav #sidenav
               mode="over"
               [(opened)]="isSidebarOpen"
               class="modern-sidenav"
               position="end"
               [fixedInViewport]="true"
               [fixedTopGap]="70">

    <div class="sidenav-header">
      <button mat-icon-button (click)="closeSidebar()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="sidenav-user">
      <div class="user-avatar-large">
        <span>{{data?.firstName?.charAt(0)}}{{data?.lastName?.charAt(0)}}</span>
      </div>
      <h3>{{data?.firstName}} {{data?.lastName}}</h3>
      <p>{{authService.isAdmin() ? 'Администратор' : 'Техничар'}}</p>
    </div>

    <mat-nav-list class="sidenav-nav">
      <a mat-list-item (click)="navigate('stolbovi/add')" *ngIf="!authService.isAdmin()">
        <mat-icon>add_circle_outline</mat-icon>
        <span>Додади Столб</span>
      </a>

      <a mat-list-item (click)="navigate('/stolbovi')" *ngIf="authService.isAdmin() || authService.isUser()">
        <mat-icon>foundation</mat-icon>
        <span>Столбови</span>
      </a>

      <a mat-list-item (click)="navigate('stolbovi/map')" *ngIf="authService.isAdmin() || authService.isUser()">
        <mat-icon>map</mat-icon>
        <span>Мапа</span>
      </a>

      <a mat-list-item (click)="navigate('/users')" *ngIf="authService.isAdmin()">
        <mat-icon>people</mat-icon>
        <span>Корисници</span>
      </a>

      <a mat-list-item (click)="navigate('/operators')" *ngIf="authService.isAdmin()">
        <mat-icon>wifi_tethering</mat-icon>
        <span>Оператори</span>
      </a>

      <a mat-list-item (click)="navigate('/reports')" *ngIf="authService.isAdmin()">
        <mat-icon>assessment</mat-icon>
        <span>Извештаи</span>
      </a>

      <div class="spacer"></div>

      <a mat-list-item class="logout-item" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Одјави се</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>
</mat-sidenav-container>
